module.exports = __webpack_public_path__ + "static/img/xuexiaojianjie.b9be64a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/xuexiaojianjie.jpg
// module id = Y57P
// module chunks = 6